import { Injectable } from "@angular/core";
import {
  StrictSqlWhereParserService, SimpleChipExpression, ExpertChipExpression, GroupChipExpression
} from "@nrwl/query-emitter";
import { GrammarHelper } from "./grammar.helper";
import { SqlWhereGrammar } from "./grammars/sql.where.grammar.type";
import { IChipRemovalDecisionMaker, AlterChipExpressionService } from "./alter.chip.expression.service";
declare var require: any;
const sqlWhereGrammarParser = require("./grammars/sql.where.grammar");

@Injectable()
export class SqlExpressionParserService extends StrictSqlWhereParserService {
  constructor() {
    super();
  }

  public isExpressionValid(expression: string): boolean {
    try {
      const kTree = sqlWhereGrammarParser.parse(expression, { types: SqlWhereGrammar });
      // all explanations are always wrapped as array
      const explanation = kTree.explain();
      let valid = true;
      explanation.forEach(subExpression => {
        valid = valid && GrammarHelper.allExpressionFieldsPopulated(subExpression);
      })
      return valid;
    } catch (error) {
      //console.error('is|valid:', error);
      return false; // normally we don't want to print error details
    }
  }

  public parseIntoTokens(expression: string): ExpertChipExpression[] {
    try {
      const kTree = sqlWhereGrammarParser.parse(expression, { types: SqlWhereGrammar });
      // all explanations are always wrapped as array
      const explanation = kTree.explain();
      explanation.forEach(token => {
        if(token.isGroup) {
          token.group.forEach(member => {
            GrammarHelper.normalizeExpertChipExpression(member);
          })
        }
        else {
          GrammarHelper.normalizeExpertChipExpression(token);
        }
      });
      return explanation;
    } catch (error) {
      //console.error('parseIntoTokens failed', error);
      return null;
    }
  }

  toExpression(chips: (SimpleChipExpression | GroupChipExpression)[]): string {
    return GrammarHelper.toExpression(chips);
  }

  // method attempts removal of 1 = 1 expressions (for me, that's redundant work. Any
  // sensible SQL engine implementation will take care to remove them before applying
  // SQL where conditions..)
  public removePlaceholders(chips: (SimpleChipExpression | GroupChipExpression)[]):(SimpleChipExpression | GroupChipExpression)[] {
    const decisionMaker = new RemovePlaceHoldersMaker();
    return AlterChipExpressionService.removePlaceholders(chips, decisionMaker);
  }

}

class RemovePlaceHoldersMaker implements IChipRemovalDecisionMaker {
  shouldRemoveChip(chip: SimpleChipExpression, trimLogicalOp: boolean): boolean {
    if ((chip as SimpleChipExpression).keyword === '1') {
      return true;
    }
    return false;
  }

}


